// ─── ACTION_ICONS map (shared across all tabs) ──────────
export const ACTION_ICONS: Record<string, string> = {
    restaurant:
        "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z",
    receipt:
        "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z",
    payment:
        "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z",
    bell:
        "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z",
    cart:
        "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z",
    star:
        "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z",
    thumbUp:
        "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z",
    info:
        "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z",
    help:
        "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z",
    wifi:
        "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z",
    qrCode:
        "M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zm8-12v8h8V3h-8zm6 6h-4V5h4v4zm-6 4h2v2h-2zm2 2h2v2h-2zm-2 2h2v2h-2zm4 0h2v2h-2zm2 2h2v2h-2zm0-4h2v2h-2zm2-2h2v2h-2z",
    settings:
        "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z",
    check:
        "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
};

// ─── Default fallback offer discount tags ──────────────────
// Extracted as named constants so the literal "-20%", "-50%", "Offert"
// never appear inline. The first two are negative-percent strings; the
// third is a label used in lieu of a discount when the offer is free.
export const FALLBACK_OFFER_DISCOUNT_MENU = "-20%";
export const FALLBACK_OFFER_DISCOUNT_HAPPY_HOUR = "-50%";
export const FALLBACK_OFFER_TAG_FREE = "Offert";

// ─── Default fallback offers ───────────────────────────────
// Rendered by OffersSection when no `offers` data is provided (Offres
// tab hasn't been visited yet, sharedOffresData is null).
//   • `titleKey` / `descriptionKey` are i18next keys, looked up at
//     render time via useTranslation so the fallback cards translate
//     alongside the rest of the UI.
//   • `imageKey` indexes into FALLBACK_OFFERS_IMAGES in OffersSection.
//   • `tag` references one of the FALLBACK_OFFER_* constants above so
//     the discount values stay centralised.
export const FALLBACK_OFFERS = [
    {
        id: 1,
        imageKey: "menuMidi",
        titleKey: "Discovery Menu",
        descriptionKey: "Starter + Main + Dessert + Wine included",
        tag: FALLBACK_OFFER_DISCOUNT_MENU,
    },
    {
        id: 2,
        imageKey: "happyHour",
        titleKey: "Happy Hour",
        descriptionKey: "Half-price cocktails 6pm-8pm",
        tag: FALLBACK_OFFER_DISCOUNT_HAPPY_HOUR,
    },
    {
        id: 3,
        imageKey: "dessert",
        titleKey: "Free Dessert",
        descriptionKey: "For any order over €25",
        tag: FALLBACK_OFFER_TAG_FREE,
    },
] as const;

// ─── Default action data for fallback ─────────────────────
export const DEFAULT_ACTIONS = [
    {
        id: 1,
        icon: "restaurant",
        iconColor: "#2E7D32",
        title: "Commander",
        description: "Voir le menu et passer commande",
        titleVisible: true,
        descriptionVisible: true,
    },
    {
        id: 2,
        icon: "receipt",
        iconColor: "#4CAF50",
        title: "Voir ma commande",
        description: "Consulter votre commande en cours",
        titleVisible: true,
        descriptionVisible: true,
    },
    {
        id: 3,
        icon: "payment",
        iconColor: "#FF9800",
        title: "Payer",
        description: "Régler l'addition",
        titleVisible: true,
        descriptionVisible: true,
    },
    {
        id: 4,
        icon: "bell",
        iconColor: "#F44336",
        title: "Appeler serveur",
        description: "Service, question ou autre demande",
        titleVisible: true,
        descriptionVisible: true,
    },
];

// ─── Types ───────────────────────────────────────────────
export type BannerPreviewData = {
    bannerEnabled: boolean;
    activeImages: Array<{
        id: number;
        url: string;
        activityId?: string;
        activityLabel?: string;
    }>;
    customTexts: Record<string, { title: string; description: string }>;
    titleVisible: boolean;
    descriptionVisible: boolean;
    titleColor?: string;
    descriptionColor?: string;
    currentSlide?: number;
    // Banner's own language picker (independent from the active rubric's
    // locale). BannerSection reads this — falling back to the project
    // default — instead of the outer selectedLanguage prop, so changing
    // the language in Offres/Actions/etc. doesn't drag the banner along.
    selectedLanguage?: string;
};

export type OffresPreviewData = {
    offersEnabled: boolean;
    titleVisible: boolean;
    sectionTitle: string;
    sectionIconPath?: string;
    customIconUrl?: string;
    offers: Array<{
        id: number;
        title: string;
        description: string;
        tag: string;
        imageUrl?: string;
    }>;
};

export type ActionsPreviewData = {
    actionsEnabled: boolean;
    sectionTitleVisible: boolean;
    sectionTitle: string;
    sectionIconPath?: string;
    customIconUrl?: string;
    actions: Array<{
        id: number;
        icon: string;
        iconColor: string;
        title: string;
        description: string;
        titleVisible: boolean;
        descriptionVisible: boolean;
    }>;
};

export type PublicitesPreviewData = {
    adsEnabled: boolean;
    sectionTitleVisible?: boolean;
    sectionTitle?: string;
    sectionIconPath?: string;
    customIconUrl?: string;
    ads: Array<{ id: number; imageUrl: string }>;
};

export type CommandePreviewData = {
    orderEnabled: boolean;
    sectionTitleVisible?: boolean;
    sectionTitle?: string;
    sectionIconPath?: string;
    customIconUrl?: string;
    showStepper?: boolean;
    showOrderDetails?: boolean;
    previewMode?: "with_order" | "no_order";
    orderStatuses?: Array<{ key: string; label: string; active: boolean }>;
};

export type SocialChannel = {
    key: string;
    label: string;
    url: string;
    enabled: boolean;
};

export type DiversPreviewData = {
    primaryColor: string;
    secondaryColor: string;
    restaurantName: string;
    restaurantDescription: string;
    nameVisible: boolean;
    descriptionVisible: boolean;
    socialChannels: SocialChannel[];
    showLegalInfo: boolean;
    enabledLanguages?: string[];
    defaultLanguage?: string;
};

export type PaiementPreviewData = {
    paymentEnabled: boolean;
    paymentMethods: Array<{
        id: string;
        icon: string;
        title: string;
        description: string;
        enabled: boolean;
        descriptionVisible?: boolean;
    }>;
    splitPaymentEnabled: boolean;
    splitOptions: Array<{
        id: string;
        icon: string;
        title: string;
        description: string;
        enabled: boolean;
        descriptionVisible?: boolean;
    }>;
};

export type AppelServeurPreviewData = {
    serverCallEnabled: boolean;
    quickOptions: Array<{
        id: string;
        icon: string;
        customIconUrl?: string;
        title: string;
        enabled: boolean;
    }>;
    customMessageEnabled: boolean;
};

// ─── Social media SVG paths ─────────────────────────────
export const SOCIAL_ICONS: Record<string, string> = {
    instagram:
        "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z",
    facebook:
        "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
    tiktok:
        "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z",
    twitter:
        "M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .386.044.762.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.247-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z",
    linkedin:
        "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
    youtube:
        "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
};

export type ScanToMobilePreviewProps = {
    mainColor: string;
    selectedLanguage: string;
    bannerData: BannerPreviewData | null;
    offresData: OffresPreviewData | null;
    actionsData: ActionsPreviewData | null;
    publicitesData: PublicitesPreviewData | null;
    commandeData: CommandePreviewData | null;
    diversData?: DiversPreviewData | null;
    paiementData?: PaiementPreviewData | null;
    showPaymentPopup?: boolean;
    appelServeurData?: AppelServeurPreviewData | null;
    showServerCallPopup?: boolean;
    // Index of the active ScanTo tab. When it changes, the preview scrolls to
    // the matching section (banner/offers/actions/order/ads/footer). Optional
    // so existing consumers that don't drive scroll keep working.
    activeTab?: number;
};

export const IMAGE_PLACEHOLDER_PATH =
    "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z";
export const DEFAULT_OFFER_ICON_PATH =
    "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z";
